module.exports = __webpack_public_path__ + "static/media/check-white.e4c6d223.svg";